module.exports = __webpack_public_path__ + "static/cardstattoo-deb07ceb4a3c4d0a2c50ab0a1f49875d.png";